import React, { useState } from 'react'
import { MetricCard } from '../components/MetricCard.jsx'
import { AlertsList } from '../components/AlertsList.jsx'
import { PrepRateBar } from '../components/PrepRateBar.jsx'
import { StatusBadge } from '../components/StatusBadge.jsx'
import { useAdminOverview } from '../hooks/useAdminOverview.js'
import { SendNotificationForm } from '@components/notifications/SendNotificationForm.jsx'

const PERIODS = ['7d', '30d', '90d']

export function OverviewPage({ onNavigate, me }) {
  const [period, setPeriod] = useState('30d')
  const { overview, alerts, loading } = useAdminOverview(period)
  const [showNotifyForm, setShowNotifyForm] = useState(false)

  if (loading) return <div style={styles.loading}>Loading…</div>

  return (
    <div>
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Overview</h2>
          <p style={styles.sub}>Last {period}</p>
        </div>
        <div style={styles.periods}>
          {PERIODS.map((p) => (
            <button
              key={p}
              style={{ ...styles.periodBtn, ...(period === p ? styles.periodActive : {}) }}
              onClick={() => setPeriod(p)}
            >
              {p}
            </button>
          ))}
        </div>
      </div>

      <div style={styles.metrics}>
        <MetricCard
          label="Active users"
          value={overview?.activeUsers}
          subtitle={`${overview?.totalUsers} total`}
          delta={overview?.activeUsersDelta}
        />
        <MetricCard
          label="Prep rate"
          value={overview ? `${Math.round(overview.prepRate * 100)}%` : '—'}
          delta={overview?.prepRateDelta ? `${Math.round(overview.prepRateDelta * 100)}%` : null}
        />
        <MetricCard
          label="Sessions created"
          value={overview?.sessionsCreated}
          subtitle={`${overview?.sessionsCompleted} completed`}
        />
        <MetricCard
          label="Avg cards/session"
          value={overview?.avgCardsPerSession}
          subtitle={overview?.mostUsedCard ? `Top: ${overview.mostUsedCard}` : null}
        />
      </div>

      <div style={styles.row}>
        <div style={styles.panel}>
          <div style={styles.panelTitle}>Prep rate by team</div>
          {overview?.teamPrepRates && overview.teamPrepRates.length > 0
            ? overview.teamPrepRates.map((t) => (
                <PrepRateBar key={t.team} team={t.team} prepRate={t.prepRate} />
              ))
            : <div style={styles.empty}>No team data</div>}
        </div>
        <div style={styles.panel}>
          <div style={styles.panelTitle}>Needs attention</div>
          <AlertsList alerts={alerts} onAlertClick={(a) => {
            if (a.type === 'orphaned_users') onNavigate('users')
          }} />
        </div>
      </div>

      <div style={{ ...styles.panel, marginTop: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: showNotifyForm ? 14 : 0 }}>
          <div style={styles.panelTitle}>Notifications</div>
          {!showNotifyForm && (
            <button
              style={styles.periodBtn}
              onClick={() => setShowNotifyForm(true)}
            >
              Send notification
            </button>
          )}
        </div>
        {showNotifyForm && me && (
          <SendNotificationForm
            me={me}
            isAdmin
            onSent={() => setShowNotifyForm(false)}
            onCancel={() => setShowNotifyForm(false)}
          />
        )}
      </div>
    </div>
  )
}

const styles = {
  loading: { fontSize: 13, color: 'var(--text-secondary)', padding: 32 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 },
  title: { fontSize: 20, fontWeight: 600, marginBottom: 2 },
  sub: { fontSize: 12, color: 'var(--text-secondary)' },
  periods: { display: 'flex', gap: 4 },
  periodBtn: { padding: '5px 12px', borderRadius: 20, border: '1px solid var(--accent-brand)', background: 'none', fontSize: 12, cursor: 'pointer', color: 'var(--accent-brand)' },
  periodActive: { background: 'var(--accent-brand)', color: '#fff', border: '1px solid var(--accent-brand)' },
  metrics: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 24 },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
  panel: { background: 'var(--surface)', borderRadius: 'var(--radius)', padding: 20, border: '1px solid var(--border)' },
  panelTitle: { fontSize: 13, fontWeight: 600, marginBottom: 14 },
  empty: { fontSize: 12, color: 'var(--text-secondary)' },
}
